import React from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import ToolTip from "../../help/ToolTip";
import TutorialPopup from "../../help/TutorialPopup"
import useInput from "../../hooks/useInput";

const TemplateInfoCard = (props)=>{
    const {template,t}=props
    const AuthorShortName = template.author_name && template.author_name.charAt(0).toUpperCase()
    const [performanceDuration, bindPerformanceDuration] = useInput(1);
    return (
        <>
            <div className="round-bg">
            
                <Col xs={12} className="no-padding">
                    <Row className="center-align" xs={12}>
                    <Col xs={6}>
                        <h5>{template.title} <span className={template.strategy=="Long"?"long":"short"}>{template.strategy}</span></h5>
                        <span className="author-name mt-2">{AuthorShortName}</span><span className="text-value">{template.author_name}</span>
                    </Col>
                    <Col xs={6}>
                        <div className="d-flex justify-content-end">
                        <div className="like-count-div"><ToolTip content={`${template.total_thumbs_up} ${template.total_thumbs_up > 1?t("renters-like-bot"):t("renter-like-bot")}`}><span className="flex-all-center"><i className="fas fa-heart like-icon"></i><i className="view-count-number like-count">{template.total_thumbs_up}</i></span></ToolTip></div>
                        
                        <div className="view-count-div"><ToolTip content={t("num-of-views")}><span className="view-count flex-all-center"><i className="far fa-eye view-icon"></i><i className="view-count-number">{template.view_count}</i></span></ToolTip></div>
                        </div>
                       
                    </Col>
                    <hr></hr>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <h5>{t("description")}</h5>
                            <p>{template.description}</p>
                        </Col>
                        <hr></hr>
                    </Row>
                    <Row>
                        <Col lg={6}>
                        <h5>{t('perf-on-listing')}<TutorialPopup content={t("template-performance-help")} /></h5>
                        <ul className="template-performance-div">
                            <li>APY: {template.apy}%</li>
                            <li>{t("performance")}: {template.performance}%</li>
                            <li>{t("w-l-ratio")}: {template.wl_ratio}%</li>
                            <li>{t("total-deals")}: {template.total_deal}</li>
                            <li>{t("a-m-d")}: {template.avg_monthly_deal}</li>
                        </ul>
                        </Col>
                        <Col lg={6}>
                        <h5>{t('live-trading-perfo')}<TutorialPopup content={t("live-trading-perfo-help")} /></h5>
                        <select  className='form-control mt-3 mb-3' {...bindPerformanceDuration}>
                            <option value="1">All time</option>
                            <option value="2">Last 3 months</option>
                        </select>
                        <ul className="template-performance-div">
                            <li>{t("avg-w-l-ratio")}: {performanceDuration==1?template.real_performances?.avg_wl:template.real_performances?.avg_wl_3_months}%</li>
                            <li>{t("total-deals")}: {performanceDuration==1?template.real_performances?.total_deal:template.real_performances?.total_deal_3_months}</li>
                        </ul>
                        </Col>
                        
                    </Row>
                    
                    
                   
                </Col>
            </div>
        </>
    );
}
export default connect(null,{})(TemplateInfoCard)